<template>
<div style="height:100%">
   <div id="cesiumContainer">
        <div id="eye"></div>
    </div>
    <div id="loadingOverlay"><h1>Loading........</h1></div>
</div>
</template>
<script>
    import * as Cesium from "cesium/Cesium";
    import widgets from "cesium/Widgets/widgets.css";
    import util from "../../components/util"
    import CesiumNavigation from "cesium-navigation-es6";
    export default {
        name: 'eye',
        components: {},
        data(){
            return{

            }
        },
        mounted() {
            var loa=document.getElementById('loadingOverlay');
       setTimeout(()=>{
           loa.style.display="none";
       },4000);
            //1、创建双球
            let viewer = util.getViewer("cesiumContainer");

            var options = {};
            // 用于在使用重置导航重置地图视图时设置默认视图控制。接受的值是Cesium.Cartographic 和Cesium.Rectangle.
            options.defaultResetView = Cesium.Cartographic.fromDegrees(110, 30, 2000000);
            // 用于启用或禁用罗盘。true是启用罗盘，false是禁用罗盘。默认值为true。如果将选项设置为false，则罗盘将不会添加到地图中。
            options.enableCompass= true;
            // 用于启用或禁用缩放控件。true是启用，false是禁用。默认值为true。如果将选项设置为false，则缩放控件 将不会添加到地图中。
            options.enableZoomControls= true;
            // 用于启用或禁用距离图例。true是启用，false是禁用。默认值为true。如果将选项设置为false，距离图例将不会添加到地图中。
            options.enableDistanceLegend= true;
            // 用于启用或禁用指南针外环。true是启用，false是禁用。默认值为true。如果将选项设置为false，则该环将可见但无效。
            options.enableCompassOuterRing= true;

            CesiumNavigation(viewer, options);
            viewer._cesiumWidget._creditContainer.style.display = "none";  //去掉logo
            // 鹰眼图
            let viewer2  = new Cesium.Viewer('eye',{
                animation: false,
                baseLayerPicker: false,
                fullscreenButton: false,
                geocoder: false,
                homeButton: false,
                sceneModePicker: false,
                selectionIndicator: false,
                timeline: false,
                navigationHelpButton: false,
                infoBox: false,
                navigationInstructionsInitiallyVisible: false
            });
            viewer2._cesiumWidget._creditContainer.style.display = "none";  //去掉logo

            //2、设置鹰眼图中球属性
            let control = viewer2.scene.screenSpaceCameraController;
            control.enableRotate = false;
            control.enableTranslate = false;
            control.enableZoom = false;
            control.enableTilt = false;
            control.enableLook = false;
            let syncViewer = function(){
                viewer2.camera.flyTo({
                    destination : viewer.camera.position,
                    orientation : {
                        heading : viewer.camera.heading,
                        pitch : viewer.camera.pitch,
                        roll : viewer.camera.roll
                    },
                    duration: 0.0
                });
            }

            //3、同步(有点卡顿)
//            viewer.camera.changed.addEventListener(syncViewer);

            //3、同步
            viewer.entities.add({
                position: Cesium.Cartesian3.fromDegrees(0, 0),
                label: {
                    text: new Cesium.CallbackProperty(function(){
                        syncViewer();
                        return "";
                    }, true)
                }
            });
        }
    }
</script>

<style>
    #cesiumContainer {
        width: 100%;
        height: 100%;
        margin: 0;
        padding: 0;
        overflow: hidden;
    }

    #eye {
        position: absolute;
        width: 20%;
        height: 20%;
        bottom: 12px;
        right: 12px;
        z-index: 999;
        background: red;
        border: solid blue 1px;
    }
</style>
